import React from 'react'
import {
  Grid,
  FormControl,
  FormControlLabel,
  Button,
  RadioGroup,
  Radio,
  TextField,
} from '@material-ui/core'
import './Style/crearFormulario.scss'
import NumberFormat from 'react-number-format'
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline'
import ReactTooltip from 'react-tooltip'

import { useFormElegibilidad } from '../../../../context/ElegibilidadContext'
import { useEligibility } from '../../../../context/EligibilityContext'

const ElegibilidadSec2View = (props) => {
  const { goToStep } = props
  const { EligibilityForm } = useFormElegibilidad()

  const [, dispatch] = useEligibility()

  const next = () => {
    dispatch({ type: 'SET_STATE', payload: 3 })
    goToStep(3)
  }

  const previous = () => {
    dispatch({ type: 'SET_STATE', payload: 1 })
    goToStep(1)
  }

  let TotalMembers = ''
  TotalMembers =
    Number(EligibilityForm.WomenCount) + Number(EligibilityForm.MenCount)
  const WomanPercent = (Number(EligibilityForm.WomenCount) / TotalMembers) * 100
  const MenPercent = (Number(EligibilityForm.MenCount) / TotalMembers) * 100
  let employess = ''
  employess =
    Number(EligibilityForm.WomenEmployees) +
    Number(EligibilityForm.MenEmployees)
  const WomanEmployesPercent =
    (Number(EligibilityForm.WomenEmployees) / employess) * 100
  const menEmployesPercent =
    (Number(EligibilityForm.MenEmployees) / employess) * 100

  return (
    <>
      <form id="sec2-form">
        <Grid item xs={12} sm={12} md={12}>
          <h1 className="h1text">INFORMACIÓN SOBRE LA MIPYME</h1>
          <br />
        </Grid>
        <Grid container spacing={1}>
          <Grid container spacing={1} className="input__container">
            <Grid item xs={12} sm={12} md={12}>
              <label className="responsiveLabel">2.1 Nombre de la MIPYME</label>
            </Grid>
            <Grid item xs={12} sm={12} md={12}>
              <FormControl style={{ width: '100%' }}>
                <TextField
                  id="MiPymeName"
                  style={{ width: '100%' }}
                  variant="outlined"
                  disabled
                  value={EligibilityForm.MiPymeName}
                />
              </FormControl>
            </Grid>
          </Grid>

          <Grid container spacing={1} className="input__container">
            <Grid item xs={8} sm={8} md={8}>
              <label className="responsiveLabel">
                2.2. Nombre del representante de la MIPYME
              </label>
            </Grid>
            <Grid item xs={4} sm={4} md={4}>
              <label className="responsiveLabel">
                Género representante legal:{' '}
                <span style={{ color: 'red' }}>*</span>
              </label>
            </Grid>
            <Grid item xs={8} sm={8} md={8}>
              <FormControl style={{ width: '100%' }}>
                <TextField
                  id="LegalRepresentativeNametxt"
                  style={{ width: '100%' }}
                  disabled
                  variant="outlined"
                  value={EligibilityForm.LegalRepresentativeName}
                />
              </FormControl>
            </Grid>

            <Grid item xs={4} sm={4} md={4}>
              <FormControl fullWidth>
                <TextField
                  id="Gender"
                  disabled
                  variant="outlined"
                  value={EligibilityForm.Gender}
                />
              </FormControl>
            </Grid>
          </Grid>

          <Grid container spacing={1} className="input__container">
            <Grid item xs={12} sm={12} md={12}>
              <label className="responsiveLabel">
                2.3. Cargo del representante de la MIPYME
              </label>
            </Grid>
            <Grid item xs={12} sm={12} md={12}>
              <FormControl style={{ width: '100%' }}>
                <TextField
                  id="Position"
                  style={{ width: '100%' }}
                  disabled
                  variant="outlined"
                  value={EligibilityForm.Position}
                />
              </FormControl>
            </Grid>
          </Grid>

          <Grid container spacing={1} className="input__container">
            <Grid item xs={12} sm={6} md={6}>
              <label className="responsiveLabel">
                2.4. Sector productivo donde opera la MIPYME{' '}
              </label>
            </Grid>
            <Grid item xs={12} sm={12} md={12}>
              <FormControl fullWidth>
                <TextField
                  id="Sector"
                  style={{ width: '100%' }}
                  variant="outlined"
                  disabled
                  value={EligibilityForm.Sector}
                />
              </FormControl>
            </Grid>
          </Grid>

          <Grid container spacing={1} className="input__container">
            <Grid item xs={12} sm={6} md={6}>
              <label className="responsiveLabel">
                2.5. País donde se localiza la MIPYME
                <span style={{ color: 'red' }}>*</span>
              </label>
            </Grid>
            <Grid item xs={12} sm={12} md={12}>
              <FormControl fullWidth>
                <TextField
                  id="MiPymeCountry"
                  style={{ width: '100%' }}
                  variant="outlined"
                  disabled
                  value={EligibilityForm.MiPymeCountry}
                />
              </FormControl>
            </Grid>
          </Grid>

          <Grid container spacing={1} className="input__container">
            <Grid item xs={12} sm={6} md={6}>
              <label className="responsiveLabel">
                2.6. Estatus legal de la MIPYME{' '}
              </label>
            </Grid>
            <Grid item xs={12} sm={12} md={12}>
              <FormControl fullWidth>
                <TextField
                  id="MiPymeType"
                  style={{ width: '100%' }}
                  variant="outlined"
                  disabled
                  value={EligibilityForm.MiPymeType}
                />
              </FormControl>
            </Grid>
          </Grid>

          {EligibilityForm.MiPymeType !== 'Persona Natural' ? (
            <Grid container spacing={1} className="input__container">
              <Grid item xs={12} sm={12} md={12}>
                <label className="responsiveLabel">
                  2.7. Estatus asociativo de la MIPYME
                </label>
              </Grid>
              <Grid
                item
                xs={12}
                sm={12}
                md={12}
                style={{ marginTop: '1%', marginBottom: '1%' }}
              >
                <label className="responsiveLabel">
                  Para MIPYME asociativa, favor desagregar la siguiente
                  información
                </label>
              </Grid>

              <Grid item xs={6} sm={6} md={6} style={{ marginTop: '1%' }}>
                <label className="responsiveLabel">
                  1. Número de mujeres socias:
                  <span style={{ color: 'red' }}>*</span>
                  <a
                    data-tip="Total de mujeres que son miembros o socios de la MIPYME."
                    data-for="infoCurrencyPop"
                    style={{ cursor: 'pointer' }}
                  >
                    <ErrorOutlineIcon fontSize="small" />
                    <ReactTooltip
                      id="infoCurrencyPop"
                      effect="solid"
                      multiline={true}
                      type="dark"
                    />
                  </a>
                </label>
              </Grid>
              <Grid item xs={3} sm={3} md={3}>
                <FormControl style={{ width: '100%' }}>
                  <NumberFormat
                    id="fullName"
                    style={{ width: '100%' }}
                    allowNegative={false}
                    customInput={TextField}
                    variant="outlined"
                    format="###"
                    value={EligibilityForm.WomenCount}
                    disabled
                  />
                </FormControl>
              </Grid>
              <Grid item xs={3} sm={3} md={3}>
                <FormControl style={{ width: '100%' }}>
                  <NumberFormat
                    id="WomanPercent"
                    style={{ width: '100%' }}
                    customInput={TextField}
                    thousandSeparator={true}
                    variant="outlined"
                    disabled
                    suffix="%"
                    value={WomanPercent.toFixed(0)}
                  />
                </FormControl>
              </Grid>

              <Grid item xs={6} sm={6} md={6} style={{ marginTop: '1%' }}>
                <label className="responsiveLabel">
                  2. Número de hombres socios:
                  <span style={{ color: 'red' }}>*</span>
                  <a
                    data-tip="Total de hombres que son miembros o socios de la MIPYME."
                    data-for="infoCurrencyPop"
                    style={{ cursor: 'pointer' }}
                  >
                    <ErrorOutlineIcon fontSize="small" />
                    <ReactTooltip
                      id="infoCurrencyPop"
                      effect="solid"
                      multiline={true}
                      type="dark"
                    />
                  </a>
                </label>
              </Grid>
              <Grid item xs={3} sm={3} md={3}>
                <FormControl style={{ width: '100%' }}>
                  <NumberFormat
                    id="MenCount"
                    style={{ width: '100%' }}
                    customInput={TextField}
                    thousandSeparator={false}
                    allowNegative={false}
                    format="###"
                    variant="outlined"
                    value={EligibilityForm.MenCount}
                    disabled
                  />
                </FormControl>
              </Grid>
              <Grid item xs={3} sm={3} md={3}>
                <FormControl style={{ width: '100%' }}>
                  <NumberFormat
                    id="fullName"
                    style={{ width: '100%' }}
                    customInput={TextField}
                    thousandSeparator={true}
                    variant="outlined"
                    disabled
                    suffix="%"
                    value={MenPercent.toFixed(0)}
                  />
                </FormControl>
              </Grid>
              <Grid item xs={6} sm={6} md={6} style={{ marginTop: '1%' }}>
                <label className="responsiveLabel">
                  3. Total de miembros o socios:
                </label>
              </Grid>
              <Grid item xs={6} sm={6} md={6}>
                <FormControl style={{ width: '100%' }}>
                  <TextField
                    disabled
                    id="fullName"
                    style={{ width: '100%' }}
                    thousandSeparator={true}
                    variant="outlined"
                    value={TotalMembers !== 0 ? TotalMembers : ''}
                  />
                </FormControl>
              </Grid>
            </Grid>
          ) : (
            <Grid container spacing={1} className="input__container">
              <Grid item xs={12} sm={12} md={12}>
                <label className="responsiveLabel">
                  2.7. Estatus asociativo de la MIPYME
                </label>
                <br />
              </Grid>

              <Grid container spacing={1} className="input__container">
                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={12}
                  style={{ marginTop: '1%', marginBottom: '1%' }}
                >
                  <label className="responsiveLabel">
                    Para MIPYME asociativa, favor desagregar la siguiente
                    información
                  </label>
                </Grid>

                <Grid item xs={6} sm={6} md={6}>
                  <label className="responsiveLabel">
                    1. Número de mujeres socias:
                    <span style={{ color: 'red' }}>*</span>
                    <a
                      data-tip="Total de mujeres que son miembros o socios de la MIPYME."
                      data-for="infoCurrencyPop"
                      style={{ cursor: 'pointer' }}
                    >
                      <ErrorOutlineIcon fontSize="small" />
                      <ReactTooltip
                        id="infoCurrencyPop"
                        effect="solid"
                        multiline={true}
                        type="dark"
                      />
                    </a>
                  </label>
                </Grid>
                <Grid item xs={3} sm={3} md={3}>
                  <FormControl style={{ width: '100%' }}>
                    <NumberFormat
                      id="fullName"
                      style={{ width: '100%' }}
                      allowNegative={false}
                      customInput={TextField}
                      variant="outlined"
                      format="###"
                      disabled
                      value={0}
                    />
                  </FormControl>
                </Grid>
                <Grid item xs={3} sm={3} md={3}>
                  <FormControl style={{ width: '100%' }}>
                    <NumberFormat
                      id="fullName"
                      style={{ width: '100%' }}
                      customInput={TextField}
                      thousandSeparator={true}
                      variant="outlined"
                      disabled
                      suffix="%"
                      value={0}
                    />
                  </FormControl>
                </Grid>

                <Grid item xs={6} sm={6} md={6}>
                  <label className="responsiveLabel">
                    2. Número de hombres socios:
                    <span style={{ color: 'red' }}>*</span>
                    <a
                      data-tip="Total de hombres que son miembros o socios de la MIPYME."
                      data-for="infoCurrencyPop"
                      style={{ cursor: 'pointer' }}
                    >
                      <ErrorOutlineIcon fontSize="small" />
                      <ReactTooltip
                        id="infoCurrencyPop"
                        effect="solid"
                        multiline={true}
                        type="dark"
                      />
                    </a>
                  </label>
                </Grid>
                <Grid item xs={3} sm={3} md={3}>
                  <FormControl style={{ width: '100%' }}>
                    <NumberFormat
                      id="MenCount"
                      style={{ width: '100%' }}
                      customInput={TextField}
                      thousandSeparator={false}
                      allowNegative={false}
                      format="###"
                      variant="outlined"
                      disabled
                      value={EligibilityForm.MenCount}
                    />
                  </FormControl>
                </Grid>
                <Grid item xs={3} sm={3} md={3}>
                  <FormControl style={{ width: '100%' }}>
                    <NumberFormat
                      id="fullName"
                      style={{ width: '100%' }}
                      customInput={TextField}
                      thousandSeparator={true}
                      variant="outlined"
                      disabled
                      suffix="%"
                      value={0}
                    />
                  </FormControl>
                </Grid>
              </Grid>
              <Grid item xs={6} sm={6} md={6} style={{ marginTop: '1%' }}>
                <label className="responsiveTy">
                  3. Total de miembros o socios:
                </label>
              </Grid>
              <Grid item xs={6} sm={6} md={6}>
                <FormControl style={{ width: '100%' }}>
                  <TextField
                    disabled
                    id="TotalMembers"
                    style={{ width: '100%' }}
                    thousandSeparator={true}
                    variant="outlined"
                    value={0}
                  />
                </FormControl>
              </Grid>
            </Grid>
          )}

          <Grid container spacing={1} className="input__container">
            <Grid item xs={12} sm={12} md={12} style={{ marginTop: '1%' }}>
              <label className="responsiveLabel">
                2.8. Número de empleados de la MIPYME desagregados por género
              </label>
            </Grid>

            <Grid item xs={6} sm={6} md={6} style={{ marginTop: '1%' }}>
              <label className="responsiveLabel">
                1. Número de mujeres empleadas:
              </label>
            </Grid>
            <Grid item xs={3} sm={3} md={3}>
              <FormControl style={{ width: '100%' }}>
                <NumberFormat
                  id="WomenEmployees"
                  style={{ width: '100%' }}
                  allowNegative={false}
                  customInput={TextField}
                  format="###"
                  variant="outlined"
                  value={EligibilityForm.WomenEmployees}
                  disabled
                />
              </FormControl>
            </Grid>
            <Grid item xs={3} sm={3} md={3}>
              <FormControl style={{ width: '100%' }}>
                <NumberFormat
                  id="womenEmployeesPercent"
                  style={{ width: '100%' }}
                  customInput={TextField}
                  thousandSeparator={true}
                  variant="outlined"
                  disabled
                  suffix="%"
                  value={WomanEmployesPercent.toFixed(0)}
                />
              </FormControl>
            </Grid>

            <Grid item xs={6} sm={6} md={6} style={{ marginTop: '1%' }}>
              <label className="responsiveLabel">
                2. Número de hombres empleados:
              </label>
            </Grid>
            <Grid item xs={3} sm={3} md={3}>
              <FormControl style={{ width: '100%' }}>
                <NumberFormat
                  id="MenEmployees"
                  style={{ width: '100%' }}
                  customInput={TextField}
                  allowNegative={false}
                  variant="outlined"
                  format="###"
                  value={EligibilityForm.MenEmployees}
                  disabled
                />
              </FormControl>
            </Grid>
            <Grid item xs={3} sm={3} md={3}>
              <FormControl style={{ width: '100%' }}>
                <NumberFormat
                  id="MenEmployees"
                  style={{ width: '100%' }}
                  customInput={TextField}
                  thousandSeparator={true}
                  variant="outlined"
                  disabled
                  suffix="%"
                  value={menEmployesPercent.toFixed(0)}
                />
              </FormControl>
            </Grid>
            <Grid item xs={6} sm={6} md={6} style={{ marginTop: '1%' }}>
              <label className="responsiveLabel">3. Total de empleados:</label>
            </Grid>
            <Grid item xs={6} sm={6} md={6}>
              <FormControl style={{ width: '100%' }}>
                <NumberFormat
                  id="fullName"
                  style={{ width: '100%' }}
                  customInput={TextField}
                  thousandSeparator={true}
                  variant="outlined"
                  disabled
                  value={employess !== 0 ? employess : ''}
                />
              </FormControl>
            </Grid>
          </Grid>

          <Grid container spacing={1} className="input__container">
            <Grid item xs={12} sm={12} md={12}>
              <label className="responsiveLabel">
                2.9. ¿La MIPYME pertenece a una comunidad indígena?{' '}
                <span style={{ color: 'red' }}>*</span>
              </label>
            </Grid>
            <Grid item xs={12} sm={12} md={12}>
              <FormControl style={{ width: '100%' }} disabled>
                <RadioGroup
                  id="IsNativeCommunity"
                  aria-labelledby="demo-radio-buttons-group-label"
                  name="radio-buttons-group"
                  value={EligibilityForm.IsNativeCommunity}
                  row
                >
                  <FormControlLabel
                    value={true}
                    control={<Radio />}
                    label="Si"
                  />
                  <FormControlLabel
                    value={false}
                    control={<Radio />}
                    label="No"
                  />
                </RadioGroup>
              </FormControl>
            </Grid>
          </Grid>

          {EligibilityForm.IsNativeCommunity === true ? (
            <Grid container spacing={1} className="input__container">
              <Grid item xs={12} sm={12} md={12}>
                <label className="responsiveLabel">
                  2.9.1. ¿A qué etnia/pueblo/comunidad pertenece?
                </label>
              </Grid>
              <Grid item xs={12} sm={12} md={12}>
                <FormControl fullWidth>
                  <TextField
                    id="detailActivity"
                    style={{ width: '100%' }}
                    variant="outlined"
                    inputProps={{ autoComplete: 'off', maxLength: 95 }}
                    disabled
                    value={EligibilityForm.NativeCommunity}
                  />
                </FormControl>
              </Grid>
            </Grid>
          ) : (
            ''
          )}

          <Grid container spacing={1} className="input__container">
            <Grid item xs={12} sm={12} md={12}>
              <label className="responsiveLabel">
                2.10. Tenencia de la tierra{' '}
                <span style={{ color: 'red' }}>*</span>
              </label>
              <br></br>
              <label className="responsiveLabel">
                Detalle el tipo de tenencia de tierra de la MIPYME, y tipo de
                derechos sobre la misma:
              </label>
            </Grid>
            <Grid item xs={12} sm={12} md={12}>
              <FormControl style={{ width: '100%' }} disabled>
                <RadioGroup
                  id="IdLandTenancy"
                  aria-labelledby="demo-radio-buttons-group-label"
                  name="radio-buttons-group"
                  value={EligibilityForm.IdLandTenancy}
                >
                  <FormControlLabel
                    value="DF"
                    control={<Radio />}
                    label={
                      <>
                        Derechos formales
                        <a
                          data-tip="Posee un título de propiedad"
                          data-for="infoCurrencyPop"
                          style={{ cursor: 'pointer' }}
                        >
                          <ErrorOutlineIcon fontSize="small" />
                          <ReactTooltip
                            id="infoCurrencyPop"
                            effect="solid"
                            multiline={true}
                            type="dark"
                          />
                        </a>
                      </>
                    }
                  />
                  <FormControlLabel
                    value="DI"
                    control={<Radio />}
                    label={
                      <>
                        Derechos informales
                        <a
                          data-tip="No posee un título de propiedad"
                          data-for="infoCurrencyPop"
                          style={{ cursor: 'pointer' }}
                        >
                          <ErrorOutlineIcon fontSize="small" />
                          <ReactTooltip
                            id="infoCurrencyPop"
                            effect="solid"
                            multiline={true}
                            type="dark"
                          />
                        </a>
                      </>
                    }
                  />
                  <FormControlLabel
                    value="AR"
                    control={<Radio />}
                    label={
                      <>
                        Arrendatario
                        <a
                          data-tip="Paga una mensualidad por hacer uso de la propiedad"
                          data-for="infoCurrencyPop"
                          style={{ cursor: 'pointer' }}
                        >
                          <ErrorOutlineIcon fontSize="small" />
                          <ReactTooltip
                            id="infoCurrencyPop"
                            effect="solid"
                            multiline={true}
                            type="dark"
                          />
                        </a>
                      </>
                    }
                  />
                </RadioGroup>
              </FormControl>
            </Grid>
          </Grid>

          <Grid container spacing={1} className="input__container">
            <Grid item xs={12} sm={12} md={12}>
              <label className="responsiveLabel">
                2.11. Liderazgo femenino en la MIPYME
              </label>
              <br></br>
            </Grid>
            <Grid
              item
              xs={6}
              sm={12}
              md={12}
              style={{ marginTop: '1%', marginBottom: '1%' }}
            >
              <label className="responsiveLabel">
                Proporcione la información a continuación:
              </label>
            </Grid>
            <Grid item xs={6} sm={6} md={6} style={{ marginTop: '1%' }}>
              <label className="responsiveLabel">
                1. Cantidad de mujeres empleadas:
              </label>
            </Grid>
            <Grid
              item
              xs={6}
              sm={6}
              md={6}
              style={{
                textAlign: 'right',
              }}
            >
              <FormControl style={{ width: '50%' }}>
                <NumberFormat
                  id="WomenEmployees"
                  style={{ width: '100%' }}
                  customInput={TextField}
                  thousandSeparator={true}
                  variant="outlined"
                  disabled
                  value={EligibilityForm.WomenEmployees}
                />
              </FormControl>
            </Grid>

            <Grid item xs={6} sm={6} md={6} style={{ marginTop: '1%' }}>
              <label className="responsiveLabel">
                2. Cantidad de mujeres en la Junta Directiva:
                <a
                  data-tip="Total de mujeres que integran la Junta Directiva."
                  data-for="infoCurrencyPop"
                  style={{ cursor: 'pointer' }}
                >
                  <ErrorOutlineIcon fontSize="small" />
                  <ReactTooltip
                    id="infoCurrencyPop"
                    effect="solid"
                    multiline={true}
                    type="dark"
                  />
                </a>
              </label>
            </Grid>
            <Grid
              item
              xs={6}
              sm={6}
              md={6}
              style={{
                textAlign: 'right',
              }}
            >
              <FormControl
                style={{
                  width: '50%',
                }}
              >
                <NumberFormat
                  id="WomenCountBoardsD"
                  style={{ width: '100%' }}
                  customInput={TextField}
                  thousandSeparator={true}
                  variant="outlined"
                  disabled
                  value={
                    EligibilityForm.MiPymeType !== 'Persona Natural'
                      ? EligibilityForm.WomenCountBoardsD
                      : 0
                  }
                />
              </FormControl>
            </Grid>

            <Grid item xs={6} sm={6} md={6} style={{ marginTop: '1%' }}>
              <label className="responsiveLabel">
                3. Cantidad de mujeres en puestos de Alta Dirección:
                <a
                  data-tip="Total de mujeres que ocupan puestos gerenciales, jefaturas, o de asesoría."
                  data-for="infoCurrencyPop"
                  style={{ cursor: 'pointer' }}
                >
                  <ErrorOutlineIcon fontSize="small" />
                  <ReactTooltip
                    id="infoCurrencyPop"
                    effect="solid"
                    multiline={true}
                    type="dark"
                  />
                </a>
              </label>
            </Grid>
            <Grid
              item
              xs={6}
              sm={6}
              md={6}
              style={{
                textAlign: 'right',
              }}
            >
              <FormControl
                style={{
                  width: '50%',
                }}
              >
                <NumberFormat
                  id="WomenCountHighDirection"
                  style={{ width: '100%' }}
                  customInput={TextField}
                  allowNegative={false}
                  format="###"
                  variant="outlined"
                  disabled
                  value={EligibilityForm.WomenCountHighDirection}
                />
              </FormControl>
            </Grid>

            <Grid item xs={6} sm={6} md={6} style={{ marginTop: '1%' }}>
              <label className="responsiveLabel">
                4. Cantidad de mujeres propietarias/socias de la MIPYME:
              </label>
            </Grid>
            <Grid
              item
              xs={6}
              sm={6}
              md={6}
              style={{
                textAlign: 'right',
              }}
            >
              <FormControl
                style={{
                  width: '50%',
                }}
              >
                {EligibilityForm.MiPymeType === 'Persona Natural' ? (
                  <NumberFormat
                    id="WomenCountOwnerSociety"
                    style={{ width: '100%' }}
                    customInput={TextField}
                    thousandSeparator={true}
                    variant="outlined"
                    disabled
                    value={EligibilityForm.Gender === 'Femenino' ? 1 : 0}
                  />
                ) : (
                  <NumberFormat
                    id="WomenCountOwnerSociety"
                    style={{ width: '100%' }}
                    customInput={TextField}
                    thousandSeparator={true}
                    variant="outlined"
                    // value desde la pregunta 7.2
                    disabled
                    value={EligibilityForm.WomenCountOwnerSociety}
                  />
                )}
              </FormControl>
            </Grid>
          </Grid>

          <Grid container spacing={1} className="button__container">
            <Grid
              item
              xs={12}
              sm={6}
              md={6}
              style={{ textAlign: 'left' }}
              className="continerButtonNav"
            >
              <Button
                onClick={() => previous()}
                variant="contained"
                className="button__wizard button__previous"
              >
                Anterior
              </Button>
            </Grid>
            <Grid
              item
              xs={12}
              sm={6}
              md={6}
              style={{ textAlign: 'right' }}
              className="continerButtonNav"
            >
              <Grid container>
                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={12}
                  style={{ textAlign: 'right' }}
                >
                  <Button
                    type="button"
                    onClick={() => {
                      next()
                    }}
                    className="button__wizard button__next"
                    disabled={false}
                  >
                    Siguiente
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </form>
    </>
  )
}
export default ElegibilidadSec2View
